import { PanelLanguage, LanguageInfo, PanelInfo } from '@interfaces/panel';
import { Theme } from '@interfaces/panel/themes';
import IService from './iService';

export default class PanelService extends IService {

    async fetchPanelInfo() {
        return await this.getAndThrowApi<PanelInfo>('/panel/info/');
    }

    async fetchPanelLanguage(lang: string) {
        return await this.getAndThrowApi<PanelLanguage>(`/api/data/lang/${lang}/`);
    }

    async fetchLanguageInfos() {
        return await this.getAndThrowApi<LanguageInfo[]>(`/api/data/lang/`);
    }

    async fetchPanelTheme(name: string) {
        const result = await fetch(`/themes/${name}/theme2.json`);
        const txt = await result.text();
        return JSON.parse(txt.replaceAll('{themeUrl}', `/themes/${name}`)) as Theme;
        //return await result.json() as Theme;
    }
}